import { isRTLLang } from '@app/utils';

/**
 * Here we define the custom popperOptions for the Header Actions Menu and bring support to RTL and LTR languages
 * @param {string} langId id of the current language
 * @returns PopperOptions Object
 */
export const getPopperOptions = langId => {
  return {
    placement: isRTLLang(langId) ? 'bottom-start' : 'bottom-end'
  };
};
